<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" title="Contents">
<p class="fmtitle"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/09_ListofIll">List of Illustrations</a></p>
<p class="toc"><a href="#/xhtml/10_Preface">Preface and Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/11_Dramatis">Dramatis Personae</a></p>
<p class="toc"><a href="#/xhtml/12_Abbreviations">List of Abbreviations</a></p>
<p class="toc"><a href="#/xhtml/13_Prologue">Prologue</a></p>
<p class="toc"><a href="#/xhtml/14_Introduction">Introduction</a></p>
<p class="toc1"><a href="#/xhtml/15_Chapter01">1.  Lessons Lived, Learned, Lost: Episodic Progress in U.S. and British Experiences in Coalition Warfare, 1900–1918</a></p>
<p class="toc1"><span href="#/xhtml/16_Chapter02" title="Link target outside of Sample">2.  Neither Friend nor Foe: U.S.-British Relations in the Interwar Years</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter03" title="Link target outside of Sample">3.  Groping in the Dark: U.S.-British Coalition Encounters, 1936–1939</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter04" title="Link target outside of Sample">4.  Ties That Bind: The Effects of Supply Negotiations on Anglo-American Cooperation, 1938–1940</span></p>
<p class="toc1"><span href="#/xhtml/19_Chapter05" title="Link target outside of Sample">5.  The Americans Come to Listen, August–September 1940</span></p>
<p class="toc1"><span href="#/xhtml/20_Chapter06" title="Link target outside of Sample">6.  Two Steps Forward, One Step Back: Inching toward Collaboration, Autumn 1940</span></p>
<p class="toc1"><span href="#/xhtml/21_Chapter07" title="Link target outside of Sample">7.  Full-Dress Talks: The American-British Conversations-1 Conference, January–March 1941</span></p>
<p class="toc1"><span href="#/xhtml/22_Chapter08" title="Link target outside of Sample">8.  Easier Said Than Done: Implementing the American-British Conversations-1 Report, April–July 1941</span></p>
<p class="toc1"><span href="#/xhtml/24_Chapter09" title="Link target outside of Sample">9.  Muddy Waters: Reexamining the Coalition’s Grand Strategy, June–October 1941</span></p>
<p class="toca"><span href="#/xhtml/25_Chapter10" title="Link target outside of Sample">10.  Racing an Unseen Clock: More Problems Than Solutions</span></p>
<p class="toc"><span href="#/xhtml/26_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/xhtml/27_Bm01" title="Link target outside of Sample">Chronology</span></p>
<p class="toc"><span href="#/xhtml/28_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/29_Bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/xhtml/30_Index01" title="Link target outside of Sample">Index</span></p>
<p class="toct"><span href="#/xhtml/23_Plate" title="Link target outside of Sample"><i>Photographs</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Contents.vue?6f6cbcf2